/**
 * UI Selector - Used to store users UI preferences
 */

import { createSelector } from 'reselect';

import { AppState } from 'services/types';
import { UiState } from './types';

const selectUi = (state: AppState): UiState => state.ui;

const selectPinnedSidebar = createSelector(
    selectUi,
    (uiState) => uiState.pinnedSidebar
);

const selectOpenSidebar = createSelector(
    selectUi,
    (uiState) => uiState.pinnedSidebar || uiState.openSidebar
);

const selectTimesheetGroupBy = createSelector(
    selectUi,
    (uiState) => uiState.timesheetGroupBy
);

const selectPickScheduleLayout = createSelector(
    selectUi,
    (uiState) => uiState.pickScheduleLayout || 'timeline'
);

export {
    selectPinnedSidebar,
    selectOpenSidebar,
    selectTimesheetGroupBy,
    selectPickScheduleLayout
};
